var React = require('react');

function EscalatorInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M14.087 42H9a6 6 0 1 0 0 12h6.432a12 12 0 0 0 9.163-4.252l22.263-26.33A4 4 0 0 1 49.913 22H55a6 6 0 1 0 0-12h-6.432a12 12 0 0 0-9.163 4.252l-22.263 26.33A4 4 0 0 1 14.087 42z","strokeLinecap":"square","key":0}),React.createElement("circle",{"strokeLinecap":"square","cx":"26","cy":"13","r":"3","key":1}),React.createElement("path",{"d":"M23 33.5V20a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6.5","key":2})]));
}

EscalatorInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = EscalatorInline;

EscalatorInline.default = EscalatorInline;
